export const comments_3899722 = {"data":{"data":[],"links":{}}}